import { render } from "./CrmEngineSolution.vue?vue&type=template&id=1bb4ee34&scoped=true"
const script = {}

import "./CrmEngineSolution.vue?vue&type=style&index=0&id=1bb4ee34&lang=scss&scoped=true"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb4ee34"]])

export default __exports__